// extracted by mini-css-extract-plugin
export var SpeechBubble = "SpeechBubble-module--SpeechBubble--2vUML";
export var content = "SpeechBubble-module--content--37Bdd";
export var bubble = "SpeechBubble-module--bubble--H9vvF";